

















import {Vue, Component, Prop} from 'vue-property-decorator';
@Component({})
export default class popUp extends Vue {
    @Prop({
        required: false,
        default: '',
    })
    private popupText!: string;
    @Prop({
        required: true,
        default: false
    })
    private showPopup!: boolean;
    @Prop({
        required: false,
        default: false
    })
    private is_input!: boolean;
    private displayPopUp = false;
}

